import {Exchange} from "app/instruments/exchange/Exchange";
import {Equality, Predicate} from "app/types/GenericTypes";

export type Securities = ReadonlyArray<CodeAndExchange>;

export interface CodeAndExchange {
    readonly code: string;
    readonly exchange: Exchange;
}

export interface UnderlyingAndExchange extends CodeAndExchange {
    readonly exchange: Exchange.ASX;
}

export interface OptionAndExchange extends CodeAndExchange {
    readonly exchange: Exchange.AOM;
}

export function securityEquality(): Equality<CodeAndExchange>;
export function securityEquality(other: CodeAndExchange): Predicate<CodeAndExchange>;

export function securityEquality(other?: CodeAndExchange): any {
    if (other == null) {
        return securityMatcher;
    } else {
        return securityPredicate(other);
    }
}

export function securityMatcher(a: CodeAndExchange, b: CodeAndExchange): boolean {
    return (a.code === b.code) && (a.exchange === b.exchange);
}

function securityPredicate(other: CodeAndExchange): Predicate<CodeAndExchange> {
    return (item) => securityMatcher(item, other);
}

export function securityHash(security: CodeAndExchange): string {
    return `${security.code}:${security.exchange}`;
}

export function encodeSecurity(security: CodeAndExchange): string {
    return `${security.code}.${security.exchange}`;
}

export function decodeSecurity(securityString: string): CodeAndExchange {
    if (!securityString.includes(".")) {
        throw Error(`${securityString} is not a valid security`);
    }
    const split = securityString.split(".");
    if (split.length !== 2) {
        throw Error(`${securityString} is not a valid security`);
    }
    const code = split[0];
    const exchange = split[1] as Exchange;
    if (!(exchange in Exchange)) {
        throw Error(`${exchange} is not a valid exchange code`);
    }

    return { code, exchange };
}
